import React, { useState } from 'react'
import { Search } from '@material-ui/icons'
import QueryAccount from 'components/QueryAccount'
import Loader from 'components/Loader'
import { parseSearchTerm } from '../../utils/utils'
import { useHistory } from 'react-router-dom'
import { useFetchPage } from 'hooks'
import * as qs from 'qs'
import { useLocale } from 'hooks'
const { REACT_APP_STRAPI_API_URL } = process.env

const CallToAction = () => {
  const { locale } = useLocale()
  const query = qs.stringify({
    populate: '*',
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/call-to-action?${query}`).then(res =>
      res.json()
    )
  const { data } = useFetchPage([`api/call-to-action`, locale], fetcher)
  const history = useHistory()

  const [inputValue, setInputValue] = useState('')
  //const [filterOpen, setFilterOpen] = useState(false)

  const handleParse = e => {
    setInputValue(e.target.value)
  }
  const hasSearch = inputValue && inputValue.length > 0
  // <============
  const [isLoading, setISLoading] = useState(false)

  return (
    <div className="SearchBnbDetail">
      <h1>{data?.title}</h1>
      <h5>{data?.subtitle}</h5>
      <div className="domainsearch learn-search">
        <QueryAccount>
          {({ account }) => {
            return (
              <div className="search-section">
                <input
                  type="search"
                  name="domainsearch"
                  value={inputValue}
                  onChange={handleParse}
                  style={{ fontSize: 18 }}
                />
                <button
                  disabled={!hasSearch || isLoading}
                  className="search-button"
                  onClick={async () => {
                    if (!hasSearch) return
                    if (account === '0') {
                      toast.error('Please connect Metamask!')
                      return
                    }

                    setISLoading(true)
                    const type = await parseSearchTerm(inputValue)

                    let searchTerm
                    searchTerm = inputValue.toLowerCase()
                    if (!searchTerm || searchTerm.length < 1) {
                      return
                    }

                    if (type === 'address') {
                      history.push(`/address/${searchTerm}`)
                      return
                    }

                    if (type === 'supported' || type === 'short') {
                      history.push(`/name/${searchTerm}/details`)
                      return
                    } else {
                      history.push(`/search/${searchTerm}`)
                    }
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {!isLoading && <Search />}
                    {data?.button?.title}.AVAX
                    {isLoading && (
                      <div style={{ marginLeft: 10 }}>
                        <Loader />
                      </div>
                    )}
                  </div>
                </button>
              </div>
            )
          }}
        </QueryAccount>
      </div>
    </div>
  )
}

export default CallToAction
